import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CheckClientVerify } from "../../api/ClientVerify";
import { LoadingDiv, SweetAlertShow } from "../master/Master";

export default function ClientVerify() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const hostname = window.location.hostname;

  useEffect(() => {
    const client = JSON.parse(localStorage.getItem("client") ?? "{}");
    if (client?.username) {
      navigate("/login");
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const addUrl = `username=${e.target.username.value}`;
      const response = await CheckClientVerify(addUrl);

      if (response?.data?.status === true) {
        localStorage.setItem("client", JSON.stringify(response.data.data));
        navigate("/login");
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="position-relative bg-school-img ">
        <div className="authentication-wrapper authentication-basic container-p-y">
          <div className="authentication-inner py-6 mx-4">
            <div className="card">
              <div className="card-body p-8">
                <form action="" onSubmit={handleSubmit}>
                  <div className="row g-4">
                    <div className="col-sm-9 m-auto text-center ri-30px fw-bold">
                      <img
                        src={hostname.includes("tifa.arjtech.xyz")?"/files/tifa_logo.png":"/files/logo.png"}
                        style={{ height: "80px" }}
                        alt=""
                      />
                    </div>
                    <div className="col-12">
                      <p className="m-0 ri-20px">
                        {" "}
                        Welcome To School Management AI Software
                      </p>
                    </div>

                    <div className="col-12">
                      <div className="form-floating form-floating-outline mb-5">
                        <input
                          type="text"
                          className="form-control input-lowercase"
                          id="username"
                          name="username"
                          placeholder="Institute Code"
                        />
                        <label htmlFor="username">Institute Code</label>
                      </div>
                      <button type="submit" className="btn btn-primary w-100">
                        Proceed to Login
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
